import React from "react";
import { Buffer } from "buffer";

if (!window.Buffer) window.Buffer = Buffer;

/**
 * Generates a cotización PDF and triggers a browser download.
 * Uses dynamic import so @react-pdf/renderer (~300KB) is only loaded on demand.
 */
export async function generateCotizacionPDF({
  venue,
  event,
  desglose,
  ivaEnabled,
  folio,
  isPremium,
  cotizacionConfig,
}) {
  const [{ pdf }, { default: CotizacionPDF }] = await Promise.all([
    import("@react-pdf/renderer"),
    import("../components/CotizacionPDF"),
  ]);

  const doc = React.createElement(CotizacionPDF, {
    venue,
    event,
    desglose,
    ivaEnabled,
    folio,
    isPremium,
    cotizacionConfig,
  });

  const blob = await pdf(doc).toBlob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${folio || "Cotizacion"}.pdf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
